module.exports = __webpack_public_path__ + "img/Gear.34a3263c.png";